/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/self-closing-comp */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

import Logo from '../../assets/Logo.png';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleToggle = () => {
    setToggleMenu(!toggleMenu);
  };

  const closeMenu = () => {
    setToggleMenu(false);
  };

  return (
    <nav className="nav container">
      <Link to="/" className="nav__logo" onClick={closeMenu}>
        <img src={Logo} alt="Haelo logo" />
      </Link>
      <div
        onClick={handleToggle}
        role="button"
        tabIndex="0"
        className="nav__toggle-container"
      >
        <div
          className={toggleMenu ? 'nav__toggle animate' : 'nav__toggle'}
        ></div>
      </div>
      <ul className={toggleMenu ? 'nav__menu active' : 'nav__menu'}>
        <li className="nav__item">
          <Link to="/" onClick={closeMenu}>
            About
          </Link>
        </li>
        <li className="nav__item">
          <Link to="/" onClick={closeMenu}>
            Features
          </Link>
        </li>
        <li className="nav__item">
          <Link to="/" onClick={closeMenu}>
            Contact Us
          </Link>
        </li>
        <li className="nav__item">
          <Link to="/login" onClick={closeMenu}>
            Login
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
